export default "__VITE_ASSET__B8gLM6Q4__"